/* @flow */

import * as entititesTypes from 'src/shared/domain/base/action/entityActionTypes';
import {
  createReducer,
  patchEntities,
} from 'src/shared/core/util/reducerUtils';

const initialState = [];

const _patchEntities = (state: Object, action: Object) =>
  patchEntities(state, action, 'expressionOfGratitude');

export default createReducer(initialState, {
  [entititesTypes.PATCH_ENTITIES]: _patchEntities,
});
